import { render, staticRenderFns } from "./BankInfoTab1.vue?vue&type=template&id=bee99152&scoped=true"
import script from "./BankInfoTab1.vue?vue&type=script&lang=js"
export * from "./BankInfoTab1.vue?vue&type=script&lang=js"
import style0 from "./BankInfoTab1.vue?vue&type=style&index=0&id=bee99152&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee99152",
  null
  
)

export default component.exports